"use client";

import { MotionConfig } from "framer-motion";

/**
 * `reducedMotion="user"` makes every `motion` component in the tree drop
 * transform and layout animations when the OS asks for reduced motion, while
 * keeping opacity: the same split the global CSS rule in `globals.css` applies
 * to everything else.
 *
 * It has to live here rather than in `globals.css` because Framer Motion writes
 * inline styles from its own frame loop; a CSS `transition-property` override
 * has nothing to act on. This is also why the wrapper exists at all:
 * `framer-motion` ships no `"use client"` directive, so importing `MotionConfig`
 * directly into a server component fails.
 */
export function MotionProvider({ children }: { children: React.ReactNode }) {
  return <MotionConfig reducedMotion="user">{children}</MotionConfig>;
}
